const invoiceErrors = {
  INVALID_REQUEST_PARAMETERS:
    "Something went wrong. Please try refreshing the page or come back later.",
  SERVICE_UNAVAILABLE:
    "Something went wrong. Please try refreshing the page or come back later.",
  INVALID_CREDENTIALS: "Sorry, You're not authorized to access this resource.",
  DEFAULT:
    "We’re unable to retrieve your invoices at the moment. Please try again later."
} as const;

export const errorMessages = {
  invoiceErrors
};

export type ApiErrorKey = keyof typeof errorMessages;
